import React, { useEffect, useState, useContext } from "react"
import CardNews from "./RecentNewsCard"
import CardNewsSkeleton from "./RecentNewsCardSkeleton"
import { LangContext } from "../../LangProvider"
import { LoadingHelper } from "../../components"
import { useFetchApi } from "../../hooks"

function RecentNews() {
  const { lang } = useContext(LangContext)
  const [news, setNews] = useState([])
  const [{ data, loading }, doFetch] = useFetchApi(
    `/news?limit=3&lang=${lang}`,
    []
  )
  const [showLoadMore, setShowLoadMore] = useState(true)
  const [newsLastId, setNewsLastId] = useState("")

  useEffect(() => {
    setNews(oldNews => [...oldNews, ...data])
    if (data.length < 3) {
      setShowLoadMore(false)
    } else {
      setShowLoadMore(true)
      setNewsLastId(data[data.length - 1]._id)
    }
  }, [data])

  useEffect(() => {
    if (news.length) {
      doFetch(`/news?limit=${news.length}&lang=${lang}`, [])
      setNews([])
    }
  }, [lang])

  return (
    <div
      className="uk-margin-large-bottom uk-text-center uk-container-large uk-container"
      id="recent-news"
    >
      <h1 className="uk-margin-small-bottom uk-text-bold">Journals</h1>
      <div
        className="uk-child-width-1-3@l uk-child-width-1-2@s uk-grid-match uk-text-center uk-padding"
        uk-grid="true"
      >
        {loading && news.length === 0 ? (
          <LoadingHelper className="uk-margin-auto">
            <CardNewsSkeleton />
          </LoadingHelper>
        ) : news.length === 0 ? (
          <h2 className="uk-width-1-1 uk-align-center">
            Sorry, we dont have journals yet
          </h2>
        ) : (
          news.map(news => (
            <div key={news._id} className="uk-margin-auto">
              <CardNews news={news} />
            </div>
          ))
        )}
      </div>
      {loading ? <div uk-spinner="ratio: 2"></div> : null}
      {loading || !showLoadMore ? null : (
        <button
          className="uk-button uk-button-default uk-text-capitalize uk-border-rounded"
          onClick={() =>
            doFetch(`/news?limit=3&last_id=${newsLastId}&lang=${lang}`, [])
          }
        >
          Load More
        </button>
      )}
    </div>
  )
}

export default RecentNews
